import { useFormContext } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { TextInput } from "react-admin";

const CustomSearch = ({ source, label }: any) => {
  const form = useFormContext();
  const values = form?.getValues();

  const handleClear = () => {
    form.setValue("q", "");
    form.setFocus("q");
  };
  return (
    <div className="flex w-full relative">
      <TextInput
        label={label}
        source={source}
        sx={{
          marginLeft: "16px",
          input: {
            paddingRight: "36px"
          }
        }}
      />
      {values?.q && (
        <IconButton
          sx={{
            width: "32px",
            height: "32px",
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: "8px",
            marginTop: "3px"
          }}
          onClick={handleClear}
        >
          <CloseIcon
            sx={{
              width: "24px",
              height: "24px"
            }}
          />
        </IconButton>
      )}
    </div>
  );
};

export default CustomSearch;
